module.exports = __webpack_public_path__ + "static/media/20180810_172533.26bb01e5.jpg";